import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

const HowWeHelp = () => {
  return (
    <section className="py-10 md:py-14 bg-primary text-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">How We Help</h2>
            <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto">
              Our solutions are grouped into three key areas so you can choose the right fit for your goals.
            </p>
          </div>

          <div className="space-y-6">
            {/* SEO & Lead Generation */}
            <div className="bg-white text-foreground rounded-3xl p-8 md:p-12">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">SEO & Lead Generation</h3>
              <p className="text-lg md:text-xl text-muted-foreground mb-8">
                Transform your online presence into a predictable client acquisition system. We help 
                premium businesses dominate local search and attract high-value clients consistently.
              </p>
              <Button 
                size="lg"
                className="bg-secondary hover:bg-secondary/90 text-white font-semibold"
                asChild
              >
                <a href="/pricing">
                  Explore SEO Services <ArrowRight className="ml-2 h-5 w-5" />
                </a>
              </Button>
            </div>

            {/* Marketing Strategy */}
            <div className="bg-white text-foreground rounded-3xl p-8 md:p-12">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">Marketing Strategy</h3>
              <p className="text-lg md:text-xl text-muted-foreground mb-8">
                Fractional CMO and agency services to help you attract high-value clients and scale 
                your marketing efforts with proven frameworks and strategic guidance.
              </p>
              <Button 
                size="lg"
                className="bg-secondary hover:bg-secondary/90 text-white font-semibold"
                asChild
              >
                <a href="/pricing">
                  Explore Marketing <ArrowRight className="ml-2 h-5 w-5" />
                </a>
              </Button>
            </div>

            {/* Business Growth */}
            <div className="bg-white text-foreground rounded-3xl p-8 md:p-12">
              <h3 className="text-3xl md:text-4xl font-bold mb-4">Business Growth</h3>
              <p className="text-lg md:text-xl text-muted-foreground mb-8">
                Strategic consulting and operational excellence programs to scale your business 
                sustainably. Build systems that create predictable, compounding growth.
              </p>
              <Button 
                size="lg"
                className="bg-secondary hover:bg-secondary/90 text-white font-semibold"
                asChild
              >
                <a href="/pricing">
                  Explore Growth Programs <ArrowRight className="ml-2 h-5 w-5" />
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowWeHelp;
